
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 489.4 489.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#777","d":"M430.55 85.5h-95.6a9.86 9.86 0 100 19.8h95.6c10.8 0 19.6 8.8 19.6 19.6v245.8c0 10.8-8.8 19.6-19.6 19.6H58.95c-10.8 0-19.6-8.8-19.6-19.6V124.9c0-10.8 8.8-19.6 19.6-19.6h97.1a9.86 9.86 0 100-19.8h-97.1c-21.7 0-39.4 17.7-39.4 39.4v245.8c0 21.7 17.7 39.4 39.4 39.4h175.9v59.5h-82.2a9.86 9.86 0 100 19.8h184.1a9.86 9.86 0 100-19.8h-82.2v-59.5h175.9c21.7 0 39.4-17.7 39.4-39.4V124.9c.1-21.7-17.6-39.4-39.3-39.4z"}}),_c('path',{attrs:{"fill":"#c60","d":"M300.55 38.9c0-21.4-17.4-38.9-38.9-38.9h-33.9c-21.4 0-38.9 17.4-38.9 38.9v23.3c0 .6.1 1.2.2 1.7-.1.6-.2 1.1-.2 1.7v193.2c0 2.2.7 4.3 2 6l45.9 60.3c1.9 2.5 4.8 3.9 7.9 3.9s6-1.4 7.9-3.9l45.9-60.3c1.3-1.7 2-3.8 2-6V65.3c0-.5-.1-1.1-.2-1.6.1-.5.2-1 .2-1.6V38.9h.1zm-91.8 33.2h26.1v175.4h-26.1V72.1zm36 230.7l-27.1-35.6h54.2l-27.1 35.6zm36-55.3h-26.1V72.1h26.1v175.4zm0-195.2h-72V38.9c0-10.5 8.6-19.1 19.1-19.1h33.9c10.5 0 19.1 8.6 19.1 19.1v13.4h-.1z"}})])
          )
        }
      }
    